// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/Users/caihan/Desktop/mdmchoi_admin/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import UserOutlined from '/Users/caihan/Desktop/mdmchoi_admin/node_modules/@ant-design/icons/es/icons/UserOutlined';
import ApartmentOutlined from '/Users/caihan/Desktop/mdmchoi_admin/node_modules/@ant-design/icons/es/icons/ApartmentOutlined';
import MailOutlined from '/Users/caihan/Desktop/mdmchoi_admin/node_modules/@ant-design/icons/es/icons/MailOutlined';
import GroupOutlined from '/Users/caihan/Desktop/mdmchoi_admin/node_modules/@ant-design/icons/es/icons/GroupOutlined';
import HomeOutlined from '/Users/caihan/Desktop/mdmchoi_admin/node_modules/@ant-design/icons/es/icons/HomeOutlined';
export default { SmileOutlined, UserOutlined, ApartmentOutlined, MailOutlined, GroupOutlined, HomeOutlined };
